import React, { Component } from 'react';
import styles from './index.css';
import { hocToolbarItem } from './toolbar-item-hoc';
import MobilePanel from './MobilePanel';

const Content = item => (
    <React.Fragment>
        <img className={styles.icon} src={item.icon} />
    </React.Fragment>
);

interface ToolbarItemShapeProps {
    icon: string;
}

interface ToolbarItemShapeState {
    selected: boolean;
    selectedIndex: number;
}


const ItemComponent = hocToolbarItem(Content);
export default class ToolbarItemShape extends Component<ToolbarItemShapeProps, ToolbarItemShapeState> {
    private mobilePanel;
    public constructor(p) {
        super(p);

        this.state = {
            selected: false,
            selectedIndex: 0,
        };
    }

    public componentWillUnmount() {
        this.mobilePanel?.hide();
    }

    public render() {
        return (
            <React.Fragment>
                <ItemComponent
                    {...this.props}
                    selected={this.state.selected}
                    content={this.getDisplayContent()}
                    handleTouchStart={this.handleTouchStart.bind(this)}
                    handleMouseDown={this.handleTouchStart.bind(this)}
                />

            </React.Fragment>
        );
    }

    private getDisplayContent() {
        const displayContent = this.props.icon;
        return displayContent;
    }

    private handleTouchStart() {
        (document.activeElement as HTMLElement).blur();      // 失去焦点，让键盘收起再弹出面板
        this.mobilePanel = MobilePanel.createMenu({
            preferredHeight: window.innerHeight / 3 * 2,
        });
        this.mobilePanel.show();
    }
}
